export const navigation = [
  { title: true, name: 'Servidor' },
  { divider: true },
  { name: 'Dashboard', url: '/dashboard', icon: 'icon-chart', badge: { variant: 'info', text: 'NEW' } },
  { name: 'Parametros', url: '/parametros', icon: 'icon-settings' },
  { name: 'Log', url: '/log', icon: 'icon-user' },
  { name: 'Grupos', url: '/grupo', icon: 'fa fa-users', badge: { variant: 'info', text: '' } },
  { name: 'Usuários', url: '/usuario', icon: 'icon-user', badge: { variant: 'info', text: '' } }
];



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/_nav.ts